import {Entity, EntityInfo} from "../../../shared-components/constants/entities"
import {getEntity} from "../entities/entitiesSelectors"

export const getFileName = (state, nanCodeIntervenant, id) => {
    const entity = getEntity(state, EntityInfo[Entity.FILE_REFUND_DEPOSITS].name, id)
    if (entity.nbDepositAttempts && entity.nbDepositAttempts > 1) {
        return nanCodeIntervenant + "_" + entity.filename.replace(".cesu", "_" + entity.nbDepositAttempts + ".cesu")
    } else {
        return nanCodeIntervenant + "_" + entity.filename
    }
}
